export const version = "address/5.0.9";
//# sourceMappingURL=_version.js.map